<div
    class="height-100 width-100 medium-padding template-radius"
    [ngStyle]="{
        'background-color': config?.backgroundColor && config.backgroundColor !== 'null' ? config.backgroundColor : 'transparent'
    }"
    [ngClass]="{
        'vertical-center': config.verticalAlignment === 'null' || config.verticalAlignment === 'middle',
        'vertical-top': config.verticalAlignment === 'top',
        'vertical-down': config.verticalAlignment === 'down'
    }"
>
    <div class="html-div" [innerHTML]="sanitizedHtml$ | async"></div>
</div>
